module.exports = __webpack_public_path__ + "img/compass-desktop-new.92024f74.svg";